import { HOUSE_GUIDE, PLANET_NAMES_HI } from './kundliGuide';
import '../../styles/kundli-experience.css';

const CELLS = [
  ['300,24 438,162 300,300 162,162',300,160], ['24,24 300,24 162,162',162,75],
  ['24,24 162,162 24,300',75,162], ['24,300 162,162 300,300 162,438',160,300],
  ['24,300 162,438 24,576',75,438], ['24,576 162,438 300,576',162,525],
  ['300,300 438,438 300,576 162,438',300,440], ['300,576 438,438 576,576',438,525],
  ['576,576 438,438 576,300',525,438], ['300,300 438,162 576,300 438,438',440,300],
  ['576,300 438,162 576,24',525,162], ['576,24 438,162 300,24',438,75],
];

export const KundliChart = ({ chart, testId = 'kundli-chart', language = 'en', selectedHouse, onHouseSelect }) => (
  <svg data-testid={testId} role="group" aria-label={`North Indian Kundli, ${chart.ascendant} ascendant`} viewBox="0 0 600 600" className="kundli-sacred-chart">
    <rect x="2" y="2" width="596" height="596" rx="2" fill="#350D16" />
    <g fill="none" stroke="#DBBD79" aria-hidden="true">
      <rect x="9" y="9" width="582" height="582" strokeOpacity=".35" />
      <rect x="24" y="24" width="552" height="552" strokeWidth="1.5" />
      {[110,180,250].map(r => <circle key={r} cx="300" cy="300" r={r} strokeOpacity=".08" />)}
      {[[16,16],[584,16],[16,584],[584,584]].map(([x,y]) => <path key={`${x}-${y}`} d={`M${x} ${y-5}l5 5-5 5-5-5Z`} fill="#DBBD79" stroke="none" />)}
    </g>
    {chart.houses.map((house, i) => {
      const [points,x,y] = CELLS[i];
      const names = house.planets.map(p => language === 'hi' ? PLANET_NAMES_HI[p] || p : p);
      const visible = names.length > 2 ? [names[0], `+${names.length-1} ${language === 'hi' ? 'ग्रह' : 'more'}`] : names;
      const label = `House ${house.house}, ${HOUSE_GUIDE[i].name}, ${house.sign}, ${house.planets.join(', ') || 'no planets'}`;
      return <g key={house.house} role={onHouseSelect ? 'button' : 'group'} tabIndex={onHouseSelect ? 0 : undefined}
        data-testid={`${testId === 'kundli-chart' ? 'kundli' : testId}-house-${house.house}`} aria-label={label}
        aria-pressed={onHouseSelect ? selectedHouse === house.house : undefined}
        onClick={() => onHouseSelect?.(house.house)} onKeyDown={e => { if (onHouseSelect && ['Enter',' '].includes(e.key)) { e.preventDefault(); onHouseSelect(house.house); } }}
        className={`kundli-house ${selectedHouse === house.house ? 'is-selected' : ''}`}>
        <title>{label}</title><polygon points={points} className="kundli-house-shape" />
        <text x={x} y={y-24} textAnchor="middle" className="kundli-house-sign">{house.house} · {house.sign.slice(0,3).toUpperCase()}</text>
        {visible.length ? visible.map((name,j) => <text key={j} x={x} y={y+2+j*23} textAnchor="middle" className="kundli-house-planet">{name}</text>)
          : <text x={x} y={y+8} textAnchor="middle" className="kundli-house-empty">—</text>}
      </g>;
    })}
    <path d="M300 291l9 9-9 9-9-9Z" fill="#DBBD79" aria-hidden="true" />
  </svg>
);